import {
  findNode, 
  stuff,
  router,
  getNavigations,
  getStage,
  IV_MENU_ITEM,
  menuTypes,
} from "@/routes/"

import {
  UPDATE_NAVIGATION
} from "@/stores/types"

/** 
 * TODO: ~~KC项目为扁平结构，目前在CSR项目中并不适用，看看改形式（数据和UI都改为扁平的），还是改逻辑代码？~~
 * 与伟豪沟通后获知，其他系统都将会存在多个场景的概念，所以需要保留这种结构。
 */
function stageListFilter(list, user, permission){
  const result = stuff(list, [], { handler:({node,level},{handler,stuff})=>{
    const navi = node.navi||{}
    const route = router.getRoutes().find(i=>i.name==node.name)
    const routeNode = router.resolve({ name: node.name })
    const type = ((node)=>{
      let result = 0
      node.children.filter(({navi={}}={})=>(typeof navi.shown == 'undefined'?true:navi.shown)).length > 0 && ++result
      level > 1 && ++result
      if(typeof node.navi.menuType !== 'undefined') result = node.navi.menuType //由sitemap.js的naviRule存入
      return result
    })(node)

    const meta = node.route?node.route.meta||{}:{}
    const shown = typeof navi.shown == 'undefined' ? Object.keys(meta.permissions||{}).some(per=>permission.hasOwnProperty(per)) : navi.shown
  
    return {
      name: node.name,
      title: navi.title || node.title,
      path: navi.path || (route?routeNode.route.path:''),
      type: menuTypes[type],
      shown,
      detail: node.detail,
      children: stuff(node.children, [], {handler,stuff})
    }
  } })
  return result
}

function navigationsFilter(tree, permissions){
  function handler({ node }, {handler,stuff}){
    const route = router.getRoutes().find(i=>i.name==node.name)
    const meta = (route||{}).meta||{}
    if(meta.permissionOn){
      node.shown = node.detail ? false : Object.keys(permissions).some(resource=>meta.permissions.hasOwnProperty(resource))
    }
    return {
      ...node,
      children: stuff(node.children,[], {handler,stuff})
    }
  }
  return stuff(tree, [], {handler})
}

export default {
  state: {
      stage: "",
      stageList: getStage(),
      list: [],
  },
  mutations: {
      [UPDATE_NAVIGATION](state, stage){//根据角色变化固定的路由
        const navigations = getNavigations()
        const stageNode = findNode(stage, navigations)
        state.list = stageNode.children
        state.stage = stage
      },
  },
  getters: {
      ['navigation'](state, _, parentState){
        const { authorization } = parentState.account
        return navigationsFilter(state.list, authorization.permission)
      },
      ['stage'](state){
        return state.stage;
      },
      ['stageList'](state, _, parentState){
        const { user, authorization } = parentState.account
        if(!user) return []
        // console.log(filter(state.stageList, user, authorization.permission))
        return stageListFilter(state.stageList, user, authorization.permission)
      }
  }
}
